import { OneClick } from './OneClick';
import { OneClick2 } from './OneClick2';
import { OneClickOuterWeb } from './OneClickOuterWeb';
import { OuterLayoutLogo } from './OuterLayoutLogo';
import { SmallOneClick } from './SmallOneClick';

export { OneClick, OneClick2, OneClickOuterWeb, SmallOneClick, OuterLayoutLogo };
